import { render, staticRenderFns } from "./remind_alert.vue?vue&type=template&id=04cedb22&scoped=true"
import script from "./remind_alert.vue?vue&type=script&lang=js"
export * from "./remind_alert.vue?vue&type=script&lang=js"
import style0 from "./remind_alert.vue?vue&type=style&index=0&id=04cedb22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cedb22",
  null
  
)

export default component.exports